export const requiredArg = description => {
  throw new TypeError(description + ' is required');
};
